import { render } from "./nodelist.vue?vue&type=template&id=51b6f65b"
import script from "./nodelist.vue?vue&type=script&lang=js"
export * from "./nodelist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__